import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import styled from 'styled-components';
import { LogbookDataForAllSubmissionsQuery } from '__generated__/graphql';
import routes from 'config/routes';
import { Link } from 'react-router-dom';
import { css } from '@emotion/react';
import {
    calcHoursBetween,
    calcTotalCat1Hours,
    calcTotalCat2Hours,
    toDate,
    atLeastFifteenMinutesInSeconds
} from '../../utils';
import { differenceInSeconds } from 'date-fns';

const StyledTableHeader = styled(TableCell)`
    &.MuiTableCell-head {
        font-weight: bold;
    }
`;

interface Props {
    data: LogbookDataForAllSubmissionsQuery;
}

export default function LogbookTable(props: Props) {
    const { data } = props;

    return (
        <TableContainer component={Paper}>
            <Table stickyHeader size="small" aria-label="a dense table">
                <TableHead>
                    <TableRow>
                        <StyledTableHeader align="center" rowSpan={2}>
                            Review
                        </StyledTableHeader>
                        <StyledTableHeader align="center" rowSpan={2}>
                            Exam ID
                        </StyledTableHeader>
                        <StyledTableHeader align="center" rowSpan={2}>
                            Date
                        </StyledTableHeader>
                        <StyledTableHeader align="center" colSpan={7}>
                            Case Type
                        </StyledTableHeader>
                        {/* <StyledTableHeader align="center" rowSpan={2}>
                            Episode Number
                        </StyledTableHeader> */}
                        <StyledTableHeader align="center" rowSpan={2}>
                            Facility
                        </StyledTableHeader>
                        <StyledTableHeader align="center" rowSpan={2}>
                            Reporting Doctor
                        </StyledTableHeader>
                        <StyledTableHeader align="center" rowSpan={2}>
                            Name of Supervising Specialist
                        </StyledTableHeader>
                        <StyledTableHeader align="center" rowSpan={2}>
                            Category 1 CPD Hours
                            <br />
                            Educational Activities
                        </StyledTableHeader>
                        <StyledTableHeader align="center" rowSpan={2}>
                            Category 2 CPD Hours
                            <br />
                            Reviewing Performance and Reflecting on Practice
                        </StyledTableHeader>
                    </TableRow>
                    <TableRow>
                        <StyledTableHeader align="center">Live</StyledTableHeader>
                        <StyledTableHeader align="center">Library</StyledTableHeader>
                        <StyledTableHeader align="center">Case From CT Course?</StyledTableHeader>
                        <StyledTableHeader align="center">DLP</StyledTableHeader>
                        <StyledTableHeader align="center">Correlated</StyledTableHeader>
                        <StyledTableHeader align="center">Non-coronary cardiac findings</StyledTableHeader>
                        <StyledTableHeader align="center">Non-cardiac findings</StyledTableHeader>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.studySubmissions?.map((row) => {
                        const cpd = row.study.cpdData;
                        if (!cpd) {
                            return;
                        }

                        const {
                            live,
                            library,
                            fromCTCourse,
                            dlp,
                            correlated,
                            nonCoronaryCardiacFindings,
                            nonCardiacFindings,
                            episodeNumber,
                            facility,
                            reportingDoctor,
                            supervisingSpecialist
                        } = cpd;
                        const { startTime, endTime, reviewSecondsSpent } = row;

                        return (
                            <TableRow key={row.id}>
                                <TableCell align="center" width="6rem">
                                    <Link to={`${routes.AUTHED.CASE_REVIEW_PAGE.url}/${row.study.id}`}>
                                        Click to review
                                    </Link>
                                </TableCell>
                                <TableCell align="center" component="th" scope="row">
                                    {row.study.id}
                                </TableCell>
                                <TableCell align="center">{toDate(row.createdAt).toLocaleDateString()}</TableCell>
                                <TableCell align="center">{live ? 'Yes' : 'No'}</TableCell>
                                <TableCell align="center">{library ? 'Yes' : 'No'}</TableCell>
                                <TableCell align="center">{fromCTCourse ? 'Yes' : 'No'}</TableCell>
                                <TableCell align="center">{dlp}</TableCell>
                                <TableCell align="center">{correlated ? 'Yes' : 'No'}</TableCell>
                                <TableCell align="center">{nonCoronaryCardiacFindings ? 'Yes' : 'No'}</TableCell>
                                <TableCell align="center">{nonCardiacFindings ? 'Yes' : 'No'}</TableCell>
                                {/* <TableCell align="center">{episodeNumber}</TableCell> */}
                                <TableCell align="center">{facility}</TableCell>
                                <TableCell align="center">{reportingDoctor}</TableCell>
                                <TableCell align="center">{supervisingSpecialist}</TableCell>
                                <TableCell align="center">
                                    {(atLeastFifteenMinutesInSeconds(
                                        differenceInSeconds(toDate(endTime), toDate(startTime))
                                    ) / 60 / 60 ).toFixed(2)} hrs
                                </TableCell>
                                <TableCell align="center">
                                    {(atLeastFifteenMinutesInSeconds(reviewSecondsSpent ?? 0) / 60 / 60).toFixed(2)} hrs
                                </TableCell>
                            </TableRow>
                        );
                    })}
                    <TableRow
                        css={css`
                            & > * {
                                font-weight: bold;
                            }
                        `}
                    >
                        <TableCell colSpan={12} />
                        <TableCell align="center">Total CPD Hours</TableCell>
                        <TableCell align="center">
                            {calcTotalCat1Hours(data?.studySubmissions ?? [])?.toFixed(2)} hrs
                        </TableCell>
                        <TableCell align="center">
                            {calcTotalCat2Hours(data?.studySubmissions ?? [])?.toFixed(2)} hrs
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    );
}
